module.exports = __webpack_public_path__ + "img/ico_zhongjidajiang.5f22e8d1.png";